import React, { useMemo } from 'react';
import styles from './Preview.module.scss';
import SVG from 'react-inlinesvg';
import boltIcon from '../../../assets/icons/tips/bolt.svg';

//Interfaces
import { SimpleTip } from '../interfaces/tip/SimpleTip';
import { CombinedTip } from '../interfaces/tip/CombinedTip';
import { MatchForecast } from '../interfaces/tip/MatchForecast';
import { OddsFormat } from '../interfaces/utils';

//Components
import { Confidence } from '../../Shops/Tip/components/TipBox/Bottom/Confidence';
import { PreviewMatchForecastInfo } from './PreviewMatchForecastInfo';
import { TipValueWithLabel } from '../../Shops/Tip/components/TipValueWithLabel/TipValueWithLabel';

//Translations
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';

//Redux
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { TipsterPreferencesState } from '../../../store/tipsterPreferences/reducer';

interface PreviewProps {
  tip: SimpleTip | CombinedTip;
  oddsFormat: OddsFormat;
  isChallenge?: boolean;
}
interface DispatchProps {
  tipsterPreferences: TipsterPreferencesState;
}
export const Preview: React.FC<PreviewProps & DispatchProps> = ({
  tip,
  oddsFormat,
  tipsterPreferences,
  isChallenge,
}) => {
  const { t } = useTranslation();
  const confidence = useMemo(() => {
    const { tipster_confidences } = tipsterPreferences.data;
    if (tipster_confidences) {
      const res = tipster_confidences.find(
        (confidence) =>
          tip.stake >= confidence.range_from &&
          tip.stake <= confidence.range_to,
      );
      return res ? res.type : 'MEDIUM';
    } else return 'MEDIUM';
  }, [tipsterPreferences, tip.stake]);

  const LC_oddsFormat: 'decimal' | 'american' | 'fractional' =
    oddsFormat.toLocaleLowerCase() as any;

  const textClass = `${styles.text} ${
    isChallenge
      ? styles[`challenge${tip.priceType}`]
      : styles[tip.priceType]
  }`;

  const svgClass = `${styles.icon} ${
    isChallenge
      ? styles[`challenge${tip.priceType}Icon`]
      : styles[`${tip.priceType}Icon`]
  }`;

  return (
    <div className={`${styles[tip.priceType]} ${isChallenge && tip.priceType === 'FREE' ? styles.challengeBetslip : ''}`}>
      <div className={styles.border}>
        <div className={styles.innerTopBox}>
          <div className={styles.unlocked}>
            {tip.matchForecasts.map((forecast: MatchForecast) => (
              <PreviewMatchForecastInfo
                forecast={forecast}
                key={forecast.index}
              />
            ))}
          </div>
        </div>
        <div className={styles.innerBottomBox}>
          <Confidence confidence={confidence} stake={tip.stake} />

          <TipValueWithLabel label={tr(t, 'odd')}>
            {tip.accumulatedOdds[LC_oddsFormat]}
          </TipValueWithLabel>
          <div className={styles.bookieTag}>
            <div className={styles.bookieTagInner}>
              <label>
                {tr(t, 'bet_done_at')} <span>{tip.bookie.name}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  tipsterPreferences: state.tipsterPreferences,
});

export const ConnectedPreview = connect(mapStateToProps)(Preview);